import React, { useEffect, useContext } from "react";
import { BrowserRouter, Route, Switch, Redirect } from "react-router-dom";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import {
	CircularProgress
} from "@material-ui/core";

import App from "./App.js";
import Portal from "./Portal.js";
import Login from "./views/general/Login";
import { UserContext } from "./contexts/UserContext";


const useStyles = makeStyles((theme) => ({
	progress: theme.progress
}));

const PrivateRoute = ({ allowedRoles = ["administrator", "agent", "tippgeber", "backoffice"], ...props }) => (
	<UserContext.Consumer>
		{({ user, loginStatus }) => {
			if (loginStatus !== "success") {
				return <Redirect to={{ pathname: "/login", state: { referrer: props.location.pathname } }} />;
			}
			if (!allowedRoles.includes(user.role)) {
				return <Redirect to={user.role === "backoffice" ? "/benutzer/" : "/finanzierungen/"} />;
			}
			return <Route {...props} />;
		}}
	</UserContext.Consumer>
);


const Router = (props) => {
	const theme = useTheme();
	const classes = useStyles();
	const userContext = useContext(UserContext);
	const isBackoffice = userContext.user.role === "backoffice";

	useEffect(() => {
		userContext.user.checkAuthenticated();
	}, []);

	//console.log("userContext.loginStatus", userContext.loginStatus);
	if (userContext.loginStatus === "loading" || (userContext.loginStatus === "success" && (!userContext.accessToken || !userContext.user.ID || !userContext.user.role))) {
		return <>
			<CircularProgress
				className={classes.progress}
				color="secondary"
			/>
		</>;
	}
	return (
		<BrowserRouter>
			<Switch>
				<Route
					exact
					path="/login"
					render={(props) => {
						return <Login {...props} />;
					}}
				/>
				{/* <Route
					exact
					path="/about"
					render={(props) => {
						return <About/>;
					}}
				/> */}
				<Route
					exact
					path="/kundenportal/:credit_id/:portal_id/:portal_key"
					render={(props) => {
						// console.log("##### routing #####");
						// console.log(props);
						return <Portal
							credit_id={parseInt(props.match.params.credit_id)}
							portal_id={parseInt(props.match.params.portal_id)}
							portal_key={props.match.params.portal_key}
						/>;
					}}
				/>
				{/* <PrivateRoute
					exact
					path="/"
					render={(props) => {
						return <App/>;
					}}
				/> */}
				<PrivateRoute
					exact
					path={["/", "/finanzierungen/"]}
					render={(props) => {
						if (isBackoffice) {
							return <Redirect to="/benutzer/" />;
						}
						return <App {...props} view="Credits" />;
					}}
				/>
				<PrivateRoute
					exact
					path={["/", "/finanzierungsarchiv/"]}
					render={(props) => {
						if (isBackoffice) {
							return <Redirect to="/benutzer/" />;
						}
						return <App {...props} view="CreditsArchive" />;
					}}
				/>
				<PrivateRoute
					exact
					path={["/potenzielle-umschuldungen/"]}
					render={(props) => {
						if (isBackoffice) {
							return <Redirect to="/benutzer/" />;
						}
						return <App {...props} view="PotentialRefinancing" />;
					}}
				/>
				<PrivateRoute
					exact
					path={["/finanzierung/:id/", "/finanzierung/:id/:view"]}
					render={(props) => {
						const { id } = props.match.params;
						if (isBackoffice) {
							return <Redirect to="/benutzer/" />;
						}
						if (userContext.user.role === "tippgeber") {
							return <Redirect to={`/antrag/${id}/`} />;
						}
						return <App {...props} view="Credit" />;
					}}
				/>
				<PrivateRoute
					exact
					path={["/antrag/:id/"]}
					render={(props) => {
						if (isBackoffice) {
							return <Redirect to="/benutzer/" />;
						}
						return <App {...props} view="CreditTipp" />;
					}}
				/>
				<PrivateRoute
					exact
					path={["/finanzierungsassistent/:id/"]}
					render={(props) => {
						if (isBackoffice) {
							return <Redirect to="/benutzer/" />;
						}
						return <App {...props} view="CreditWizard" />;
					}}
				/>
				<PrivateRoute
					exact
					path={["/kreditvergleich/"]}
					render={(props) => {
						if (isBackoffice) {
							return <Redirect to="/benutzer/" />;
						}
						return <App {...props} view="Compares" />;
					}}
				/>
				<PrivateRoute
					exact
					path={["/kreditvergleich/:id/"]}
					render={(props) => {
						if (isBackoffice) {
							return <Redirect to="/benutzer/" />;
						}
						return <App {...props} view="Compare" />;
					}}
				/>
				<PrivateRoute
					exact
					path={["/profile/"]}
					render={(props) => {
						return <App {...props} view="Profile" />;
					}}
				/>
				<PrivateRoute
					exact
					path={["/benutzer/"]}
					allowedRoles={["administrator", "backoffice"]}
					render={(props) => {
						return <App {...props} view="UserManagement" />;
					}}
				/>
				<PrivateRoute
					exact
					path={["/einstellungen/"]}
					allowedRoles={["administrator"]}
					render={(props) => {
						return <App {...props} view="Settings" />;
					}}
				/>
				<PrivateRoute
					exact
					path={["/benachrichtigungen/"]}
					allowedRoles={["administrator"]}
					render={(props) => {
						return <App {...props} view="NotificationSettings" />;
					}}
				/>
				<PrivateRoute
					exact
					path={["/benutzereinstellungen/"]}
					allowedRoles={["administrator", "agent"]}
					render={(props) => {
						return <App {...props} view="UserSettings" />;
					}}
				/>

				{/* <Route component={NotFound} /> */}
			</Switch>
		</BrowserRouter>
	);
};

export default Router;
